// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const selectModule = createAction('[Custom PDF Report Builder] Select Module', props());
